// Capacité (passagers / bagages) d'une formule de course, agrégée depuis son pool de véhicules.
// SOURCE UNIQUE des libellés passagers / petits et grands bagages, partagée entre les pills du tunnel
// ride (RideTunnel) et les cartes catalogue des sites publics (blocs prestation-*).

export interface RideCapacityLike {
  pax_min?: number;
  pax_max?: number;
  small_luggage_min?: number;
  small_luggage_max?: number;
  large_luggage_min?: number;
  large_luggage_max?: number;
}

export interface RideCapacityLabels {
  /** ex. « passagers » — mis en minuscules dans le libellé. */
  passengers: string;
  small_luggage: string;
  large_luggage: string;
}

/**
 * Libellé de capacité d'une formule de course.
 *
 * - Une partie (passagers / bagages) n'apparaît que si sa borne `*_max` est définie (une borne
 *   absente = « pas de contrainte » sur cet axe, on ne l'affiche pas).
 * - Borne `*_min` absente : défaut 1 passager / 0 bagage (miroir des pills du RideTunnel).
 * - Aucune borne → chaîne vide (l'appelant n'affiche alors rien).
 *
 * Ex. `{ pax_max: 7, large_luggage_max: 6 }` → « 1–7 passagers · 0–6 grands bagages ».
 */
export function formatRideCapacityLabel(capacity: RideCapacityLike, labels: RideCapacityLabels): string {
  return [
    capacity.pax_max != null ? `${capacity.pax_min ?? 1}–${capacity.pax_max} ${labels.passengers.toLowerCase()}` : null,
    capacity.small_luggage_max != null
      ? `${capacity.small_luggage_min ?? 0}–${capacity.small_luggage_max} ${labels.small_luggage.toLowerCase()}`
      : null,
    capacity.large_luggage_max != null
      ? `${capacity.large_luggage_min ?? 0}–${capacity.large_luggage_max} ${labels.large_luggage.toLowerCase()}`
      : null,
  ]
    .filter(Boolean)
    .join(' · ');
}
